import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import "./coffePauseProgress.css";
import { useTranslation } from "react-i18next";
import { stopPause } from '../../store/coffePauseSlice';
import coffe from "../../../../assets/coffe.svg"
import blackCoffe from "../../../../assets/coffe-black.svg"
import { addBreakTime } from "../../store/coffePauseThunks";
// Custom hook déplacé ou exporté pour la clarté
function useMobile() {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return isMobile;
}

export default function CoffePauseProgress() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isMobile = useMobile();
    const [isExpanded, setIsExpanded] = useState(false);
    const [progress, setProgress] = useState(0);
    const [timeLeft, setTimeLeft] = useState("");
    const { localAvatar } = useSelector(state => state.auth);

    const {
      
        cafePauseActive,
        cafePauseDuration,
        cafePauseStartTime
    } = useSelector((state) => state.coffePause);

    const {
        sessionView
    } = useSelector((state) => state.productivitySession);
    const getStartTimeInMs = (timeString) => {
        if (!timeString) return null;

        // Si c'est une date complète ISO
        if (timeString.includes('T') || timeString.includes('-')) {
            return new Date(timeString).getTime();
        }

        // Si c'est juste "HH:MM:SS", on l'applique au jour actuel
        const [hours, minutes, seconds] = timeString.split(':');
        const d = new Date();
        d.setHours(parseInt(hours), parseInt(minutes), parseInt(seconds), 0);
        return d.getTime();
    };
    useEffect(() => {
        // Le composant s'affiche si l'un des deux flags est vrai
        if (!( cafePauseActive) || !cafePauseDuration || !cafePauseStartTime) return;
        const startTimeMs = getStartTimeInMs(cafePauseStartTime);

        const durationInMs = cafePauseDuration * 60 * 1000;

        const updateTimer = () => {
            const now = Date.now();
            const elapsed = now - startTimeMs;

            // Calcul du pourcentage
            const percent = Math.min((elapsed / durationInMs) * 100, 100);
            setProgress(percent);

            // Calcul du temps restant précis
            const remainingMs = Math.max(0, durationInMs - elapsed);
            const totalSeconds = Math.ceil(remainingMs / 1000);
            const mins = Math.floor(totalSeconds / 60);
            const secs = totalSeconds % 60;

            // Format 00:00 pour plus de lisibilité
            setTimeLeft(`${mins} ${t("mins")} ${secs < 10 ? '0' : ''}${secs} ${t("secs")}`);

            if (percent >= 100) {
                dispatch(stopPause());
                dispatch(addBreakTime({ body: { userId: localAvatar.id, time: null } }));

            }
        };

        updateTimer();
        const interval = setInterval(updateTimer, 1000);
        return () => clearInterval(interval);
    }, [ cafePauseActive, cafePauseDuration, cafePauseStartTime]);

    const handleStopPause = () => {
        dispatch(stopPause());
        dispatch(addBreakTime({ body: { userId: localAvatar.id, time: null } }));
        setIsExpanded(false);
    };

     const size = 45;
    const strokeWidth = 2;
    const center = size / 2;
    const radius = 20;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    // Condition d'affichage : Doit être cohérente avec le useEffect
    if (!cafePauseActive) {
        return null;
    }

    const renderPauseModal = () => (
        <div className="coffe-pause-overlay" onClick={() => setIsExpanded(false)}>
            <div className="coffe-pause-modal-centered" onClick={(e) => e.stopPropagation()}>
                <div className="coffe-pause-header">
                    <div className="coffe-pause-header-center">
                        {t("end_break_coffe")}
                        <img
                            className="coffe-pause-header-icon"
                            src={blackCoffe}
                            alt="Coffee Icon"
                        />
                    </div>
                    <div className="coffe-pause-header-right">
                        <Button className="close-button" onClick={() => setIsExpanded(false)}>
                            <span className="material-symbols-outlined">close</span>
                        </Button>
                    </div>
                </div>

                <div className="coffe-pause-content" style={{ width: '100%' }}>
                    <span className="coffe-pause-content-text" style={{ textAlign: 'center', display: 'block' }}>
                        {t("break_msg")}
                    </span>
                </div>

                <div className="timer-container" style={{ width: '100%', marginTop: '10px' }}>
                    <div className="timer-text-coffe" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <span style={{ fontWeight: 'bold' }}>{t("on_break")}</span>
                        <span>{timeLeft} restantes</span>
                    </div>
                    <div className="progress-session-bar" style={{ height: '8px', backgroundColor: '#eee', borderRadius: '4px', overflow: 'hidden' }}>
                        <div className="progress-bar-fill-session" style={{ width: `${progress}%`, backgroundColor: '#DC6803', height: '100%', transition: 'width 1s linear' }}></div>
                    </div>
                </div>

                <div className="coffe-pause-button-container">
                    <button type="button" className="coffe-pause-button-stop" onClick={handleStopPause}>
                        {t("end_break")}
                    </button>
                </div>
            </div>
        </div>
    );

        return (
        <>
            <div
                className={`coffe-pause-progress-fab-container ${isMobile ? "mobile-pos" : ""} ${(sessionView !== "progress" && !isMobile)? "session-inactive" : ""}` }
                onClick={() => setIsExpanded(true)}
                
            >
                <div className="coffe-pause-fab-circle" style={{ width: size, height: size, position: 'relative' }}>
                    <svg   viewBox={`0 0 ${size} ${size}`} className="session-timer-svg">
                        <circle stroke="#E0E0E0" 
                        strokeWidth={strokeWidth} fill="transparent"
                                r={radius} cx={center} cy={center} />
                            <circle
                                stroke="#DC6803"
                                strokeWidth={strokeWidth}
                                fill="transparent"
                                r={radius} cx={center} cy={center}
                                strokeDasharray={circumference}
                                strokeDashoffset={strokeDashoffset}
                                strokeLinecap="round"
                                style={{ transition: 'stroke-dashoffset 1s linear' }}
                            />
                        </svg>
                        <img className="coffe-pause-fab-icon"
                            src={coffe}
                            alt="Coffee Icon"
                            style={{
                                position: 'relative',
                                filter: 'invert(46%) sepia(93%) saturate(3025%) hue-rotate(15deg) brightness(94%) contrast(98%)'
                            }} />

                </div>
                <div className="coffe-pause-fab-text">{timeLeft}</div>
            </div>
      {isExpanded && isMobile && (
                <div className="mobile-popup-overlay" onClick={() => setIsExpanded(false)} style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div onClick={(e) => e.stopPropagation()}>{renderPauseModal(true)}</div>
                </div>
            )} 
            {isExpanded && !isMobile &&(
                renderPauseModal(false)
            )} 
        </>
        );
    
}